import React, { useEffect } from "react";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import {
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Row,
  Icon,
  Block,
} from "../../components/Component";
import { Card } from "reactstrap";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getBookingDetail } from "../../slice/booking-detail";
import get from "lodash/get";
import moment from "moment";

const getValue = (obj, paths, fallback = "N/A") => {
  for (const path of paths) {
    const value = get(obj, path);
    if (value !== undefined && value !== null && value !== "") {
      return value;
    }
  }
  return fallback;
};

const formatDate = (obj, paths) => {
  const date = getValue(obj, paths, null);
  return date ? moment(date).format("DD/MM/YYYY HH:mm") : "N/A";
};

const formatDuration = (obj) => {
  const amount = getValue(obj, ["durationInput.amount", "duration"], null);
  const unit = getValue(obj, ["durationInput.unit"], "").trim();
  if (!amount) return "N/A";
  return `${amount}${unit ? ` ${unit}` : ""}`;
};

const renderItem = (label, value) => (
  <div className="d-flex justify-content-between align-items-center py-2">
    <span className="text-muted">{label}</span>
    <span className="fw-bold text-end text-break">{value}</span>
  </div>
);

const BookingDetailPage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getBookingDetail(id));
  }, [id, dispatch]);

  const { booking } = useSelector((state) => state.bookingDetail);
  const customer = booking?.applier || null;
  const provider = booking?.provider || null;
  const service = booking?.service || booking?.product || booking?.package;
  const applier = booking?.applier || booking?.applicant || null;

  return (
    <React.Fragment>
      <Head title="Booking Detail"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween className="g-3">
            <BlockHeadContent>
              <BlockTitle>Booking Details</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <Link to={`/bookings`}>
                <Button
                  color="light"
                  outline
                  className="bg-white d-none d-sm-inline-flex"
                >
                  <Icon name="arrow-left"></Icon>
                  <span>Back</span>
                </Button>
              </Link>
              <Link to={`/bookings`}>
                <Button
                  color="light"
                  outline
                  className="btn-icon bg-white d-inline-flex d-sm-none"
                >
                  <Icon name="arrow-left"></Icon>
                </Button>
              </Link>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        {booking && (
          <Block>
            <Row className="g-gs">
              <Col xl={6}>
                <Card>
                  <div className="card-inner">
                    <h5 className="card-title mb-3">Booking Information</h5>
                    {renderItem(
                      "Booking Status",
                      getValue(booking, ["status", "state"])
                    )}
                    {renderItem(
                      "Payment Status",
                      getValue(booking, [
                        "paymentStatus",
                        "payment.status",
                        "paymentStatusLabel",
                      ])
                    )}
                    {renderItem(
                      "Payment Method",
                      getValue(
                        booking,
                        ["paymentMethod", "payment.method"],
                        "N/A"
                      )
                    )}
                    {renderItem(
                      "Payment ID",
                      getValue(booking, ["paymentId", "payment.id"], "N/A")
                    )}
                    {renderItem(
                      "Created At",
                      formatDate(booking, ["createdAt"])
                    )}
                    {renderItem(
                      "Total",
                      getValue(booking, [
                        "total",
                        "totalPrice",
                        "price",
                        "amount",
                      ])
                    )}
                    {renderItem(
                      "Notes",
                      getValue(booking, ["note", "notes"], "None")
                    )}
                  </div>
                </Card>
              </Col>
              <Col xl={6}>
                <Row className="g-gs">
                  <Col lg={12}>
                    <Card>
                      <div className="card-inner">
                        <h5 className="card-title mb-3">Customer</h5>
                        {customer ? (
                          <>
                            {renderItem(
                              "Name",
                              getValue(customer, [
                                "fullName",
                                "name",
                                "username",
                              ])
                            )}
                            {renderItem(
                              "Email",
                              getValue(customer, ["email"], "N/A")
                            )}
                            {renderItem(
                              "Phone",
                              getValue(
                                customer,
                                ["phone", "phoneNumber"],
                                "N/A"
                              )
                            )}
                          </>
                        ) : (
                          <div className="text-muted">No customer data</div>
                        )}
                      </div>
                    </Card>
                  </Col>
                  <Col lg={12}>
                    <Card>
                      <div className="card-inner">
                        <h5 className="card-title mb-3">Provider</h5>
                        {provider ? (
                          <>
                            {renderItem(
                              "Name",
                              getValue(provider, [
                                "fullName",
                                "name",
                                "username",
                              ])
                            )}
                            {renderItem(
                              "Email",
                              getValue(provider, ["email"], "N/A")
                            )}
                            {renderItem(
                              "Service Type",
                              getValue(provider, ["serviceType", "role"], "N/A")
                            )}
                          </>
                        ) : (
                          <div className="text-muted">No provider data</div>
                        )}
                      </div>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Block>
        )}
      </Content>
    </React.Fragment>
  );
};

export default BookingDetailPage;
